// eslint-disable-next-line import/no-mutable-exports
let rollbar

if (process.server) {
  const Rollbar = require('rollbar')

  rollbar = new Rollbar({
    accessToken: process.env.ROLLBAR_DEPLOY_ACCESS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: process.env.LOCAL_PROD_BUILD ? 'development' : process.env.NODE_ENV,
    },
    ignoredMessages: [
      /Loading chunk/,
      /Script error/,
      /Blocked a frame with origin/,
      /cancelled/,
      /cancelado/,
      /unable to load due to an `error` event on it/,
      /Script error/,
      /ResizeObserver/,
      /avast/,
      /Request timed out before getting a response/,
      /Network Error/,
    ],
  })
} else if (process.client) {
  rollbar = window.Rollbar
}

export default rollbar
